import type { FormInstance } from "antd";

import { useCallback, useState } from "react";

import type { ValidateErrorInfo } from "../types";

export const useStepValidation = (form: FormInstance) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const checkSubmitButtonState = useCallback(() => {
    const errors = form.getFieldsError();
    const hasErrors = errors.some(field => field.errors.length > 0);
    setSubmitDisabled(hasErrors);
  }, [form]);

  const validateAllFieldsAndUpdateSubmitState = useCallback(async () => {
    try {
      await form.validateFields();
      setSubmitDisabled(false);
      return true;
    } catch (error) {
      const validationError = error as ValidateErrorInfo;
      setSubmitDisabled(!!validationError.errorFields?.length);
      return false;
    }
  }, [form]);

  const changeStep = async (step: number) => {
    const isValid = await validateAllFieldsAndUpdateSubmitState();
    // Step validation is triggered when the current step is valid and
    // the user attempts to navigate to the next page,
    // as well as when the user navigates back to the previous page.
    if (isValid || step < currentStep) {
      setCurrentStep(step);
    }

    return isValid;
  };

  return {
    currentStep,
    submitDisabled,
    changeStep,
    validateAllFields: validateAllFieldsAndUpdateSubmitState,
    checkSubmitButtonState,
  };
};
